/* eslint-disable */
// lint to be fixed in this ticket: https://lastbrand.atlassian.net/browse/ECOMP-3295
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable import/order */
/*
 * TODO: IMPORTANT IMPORTANT IMPORTANT
 * DO NOT CHANGE THE ORDER OF IMPORTS HERE IT WILL BREAK THE BUILD
 *
 * import { getCartAuthCodeFromHeader } from '../../../services/cartService/cart.service.helper'
 */
import { LOCAL_STORAGE_NEW_CART_ID_KEY } from '../../../services/checkoutService/new-checkout.constants'
import { getCartAuthCodeFromHeader } from '../../../services/cartService/cart.service.helper'

import { CONFIG_BUILD_ENV } from '@src/config/env'
import { LineItemDetails } from '@src/quince-site-common/src/organisms/appLayout/molecules/cartPopUp/cart.helper'
import {
  Cart,
  CartLineItem,
  PromoAllocation,
} from '@src/quince-site-common/src/services/cartService/cart.service.types'

import isBrowser from '@src/quince-site-common/src/utils/isBrowser'
import { INVENTORY_STATUS } from '@src/quince-site-common/src/services/cartService/cart.service.constants'
import { getStorage } from '@src/utils/enhancedStorage'

export function getLineItem(newCheckout: Cart) {
  return newCheckout?.lineItems
}

export function getLineItemId(lineItem: CartLineItem) {
  return lineItem?.variantId
}

export function getSvidFromEdge(edge: CartLineItem) {
  return edge?.productMetaData?.svid
}

export function getSpid(lineItem: CartLineItem) {
  return lineItem?.productMetaData?.spid
}

export function getSelectedOptionsFromLineItem(lineItem: CartLineItem) {
  return lineItem?.productMetaData?.options
}

export function getLineItemsSubtotalPriceAmount(node?: Cart) {
  return node?.cartCostSummary?.subTotalAmount
}
export function getLineItemsCurrencyCode(node: Cart) {
  return node?.currencyCode || ''
}

export function getSubtotalPriceV2(node: Cart) {
  return node?.cartCostSummary?.totalAmount
}

export function getLineItemEdges(node: Cart) {
  return node?.lineItems
}

export function getSaveForLaterItems(node: Cart) {
  return node?.saveForLaterItems
}

export function getOutOfStockItems(node: Cart) {
  return node?.outOfStockLineItems || []
}

export function getProductID(lineItem?: CartLineItem) {
  return lineItem?.variantMetaData?.productId
}

export function getVariantId(lineItem: CartLineItem) {
  return lineItem?.variantMetaData?.variantId
}

export function getSvid(lineItem: CartLineItem) {
  return lineItem?.productMetaData?.svid
}

export function getVariantSelectedOptions(lineItem: CartLineItem) {
  return lineItem?.productMetaData?.options
}

export function getVariantIdFromEdge(edge: CartLineItem) {
  return edge?.variantId
}

export function getVariantProductIdFromEdge(edge: any) {
  return edge?.lineItem?.variantId
}

export function getVariantProductId(node: any) {
  return node?.lineItem?.variantId
}

export function getIdFromEdge(edge: CartLineItem) {
  return edge.id
}

export function getQuantityFromEdge(edge: CartLineItem): number | undefined {
  return edge?.quantity
}

export function getLineItemFromEdge(edge?: CartLineItem): CartLineItem | undefined {
  return edge
}

export function getLineItemDetails(lineItems: CartLineItem[]): Record<string, LineItemDetails> {
  return lineItems.reduce((acc: Record<string, LineItemDetails>, curr) => {
    const { variantId: internalVariantId, productId: internalProductId, price } = curr.variantMetaData || {}

    const variantTitle = curr.variantMetaData?.variantTitle || ''
    const color = variantTitle.split(' / ')[1] || ''

    let productLink = curr.slug ? `/${curr.slug}` : ''
    if (productLink && color) {
      productLink += `?color=${encodeURIComponent(color.toLowerCase())}`
    }

    return {
      ...acc,
      [curr.variantId]: {
        productLink,
        internalVariantId,
        internalProductId,
        price,
      },
    }
  }, {})
}

export function getIsAnyItemOutOfStock(lineItems: any[]) {
  return lineItems?.some(
    lineItem =>
      lineItem?.inventoryStatus === INVENTORY_STATUS.OUT_OF_STOCK ||
      lineItem?.inventoryStatus === INVENTORY_STATUS.PARTIAL_OUT_OF_STOCK,
  )
}

export function getQuantityAvailableFromLineItem(lineItem: CartLineItem) {
  return lineItem?.inventoryData?.available
}

export function getProductFromLineItem(lineItem: CartLineItem) {
  return lineItem?.variantMetaData
}

export function getProductTitleFromLineItem(lineItem: CartLineItem) {
  return lineItem?.variantMetaData?.productTitle
}

export function getVariantTitleFromLineItem(lineItem: CartLineItem) {
  // replace One Size, default, One Color, No Color with empty string
  // same is being shown in CA as well

  const ignoredVariantsUS: string[] = ['One Size', 'default', 'One Color', 'No Color']
  const ignoredVariantsCA: string[] = [
    // fr-ca
    'Taille unique',
    'par défaut',
    'Une couleur',
    'Aucune couleur',

    // for en-ca
    'One Size',
    'default',
    'One Colour',
    'No Colour',
  ]

  let variantTitle = lineItem?.variantMetaData?.variantTitle || ''

  // replace the changes
  ;[...ignoredVariantsUS, ...ignoredVariantsCA].forEach((variant: string) => {
    const regex = new RegExp(variant, 'gi')
    variantTitle = variantTitle?.replace(regex, '')
  })

  return variantTitle
    ?.split(' / ')
    .filter(title => Boolean(title))
    .join(' / ')
}

export function getCustomAttributes(lineItem?: CartLineItem) {
  return lineItem?.attributes || []
}

export function getProductImageFromLineItem(lineItem: CartLineItem) {
  return lineItem?.variantMetaData?.imageUrl
}

export function getPreOrderShippingData(lineItem: CartLineItem) {
  return lineItem?.variantMetaData?.imageUrl
}

export function getSvMetaField(lineItem: CartLineItem) {
  const quantityAvailable = getQuantityAvailableFromLineItem(lineItem)

  const { inventoryData } = lineItem
  return {
    svMetaField: inventoryData,
    shippingDate: inventoryData?.tags?.preOrderShippingDate,
    quantityAvailable,
  }
}

export function getVariantPrice(lineItem: CartLineItem) {
  return lineItem?.variantMetaData?.price
}

export function getProductTitleFromNode(lineItem: CartLineItem) {
  return lineItem?.variantMetaData?.productTitle
}

export function getVariantTitleFromNode(lineItem: CartLineItem) {
  return lineItem?.variantMetaData?.variantTitle
}

export function getVariantSkuFromNode(lineItem: CartLineItem) {
  return lineItem?.variantMetaData?.variantTitle
}

export function getVarientId(variant: any) {
  return variant?.id
}

export function isEqualId(id: string, filterIdForVariant: string) {
  return id === filterIdForVariant
}

export function getCartIDAndAuth() {
  return {
    cartID: isBrowser() ? getStorage().getItem(LOCAL_STORAGE_NEW_CART_ID_KEY, { isGlobal: false }) : null,
    authCode: getCartAuthCodeFromHeader(),
  }
}

export const getCheckoutToken = (): string => {
  const { cartID } = getCartIDAndAuth()
  return cartID ?? ''
}

export function getCreatedAt(lineItem: CartLineItem) {
  return lineItem?.createdAt
}

export function getDiscountAllocations(lineItem: CartLineItem): PromoAllocation[] {
  return (
    lineItem?.costSummary?.promoAllocations.filter(promoAllocation => promoAllocation.promoType === 'MONEY_DISCOUNT') ||
    []
  )
}

export function getDiscountTitle(allocation: PromoAllocation) {
  return (allocation as PromoAllocation)?.promoCode
}

export function getDiscountAmount(allocation: PromoAllocation) {
  return allocation?.amount
}

export function getSpidForLineItem(lineItem: CartLineItem) {
  return lineItem?.productMetaData?.spid
}

export function getSwatchesId(lineItem: any) {
  return lineItem?.variantId
}
export function getSwatchesIdFromLineItem(lineItem: any) {
  return lineItem?.variantId
}
export const getpayloadForRemoveLineItems = (lineItem: any) => {
  return {
    lineItemId: getIdFromEdge(lineItem),
    adjustment: -1,
  }
}

/* eslint-enable */
